export default "__VITE_ASSET__CJAf4zCC__"